/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSkewY = createReactComponent("skew-y", "IconSkewY", [
  [
    "path",
    {
      d: "M4.326 19h15.348a1 1 0 0 0 .962 -1.275l-3.429 -12a1 1 0 0 0 -.961 -.725h-8.492a1 1 0 0 0 -.961 .725l-3.429 12a1 1 0 0 0 .962 1.275z",
      key: "svg-0"
    }
  ]
]);

export { IconSkewY as default };
//# sourceMappingURL=IconSkewY.js.map
